import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function LoadingSkeleton(props) {
    const { height } = props
    return (
        <React.Fragment>
            <div className="mb-lg-4">
                <Skeleton count={1} height={height} width={"100%"} />
            </div>

        </React.Fragment>
    )
}

export default memo(LoadingSkeleton)